import { z } from "zod";

// Curated set of editable text blocks per marketing page. Each entry maps to a
// `[data-cms="<page>.<key>"]`-bearing element on the public site (the static
// default stays as fallback / first paint). Keep this list tight — this is a
// lightweight content editor, not a page builder.
export const PAGE_BLOCKS = [
  // Home (home_a variant — apps/public/src/index.html)
  { page: "home", key: "hero.eyebrow", label: "Home · Eyebrow hero", type: "text" },
  { page: "home", key: "hero.headline", label: "Home · Titolo hero", type: "text" },
  { page: "home", key: "hero.sub", label: "Home · Sottotitolo hero", type: "textarea" },
  { page: "home", key: "hero.ctaPrimary", label: "Home · Pulsante primario", type: "text" },
  { page: "home", key: "selection.title", label: "Home · Titolo selezione", type: "text" },
  { page: "home", key: "zones.title", label: "Home · Titolo zone", type: "text" },
  // Contatti (apps/public/src/contatti.html)
  { page: "contatti", key: "hero.lead", label: "Contatti · Sottotitolo hero", type: "textarea" },
  { page: "contatti", key: "address", label: "Contatti · Indirizzo", type: "text" },
  { page: "contatti", key: "phone", label: "Contatti · Telefono", type: "text" },
  { page: "contatti", key: "email", label: "Contatti · Email", type: "text" },
  { page: "contatti", key: "hours", label: "Contatti · Orari", type: "textarea" },
] as const;

export type PageBlockDef = (typeof PAGE_BLOCKS)[number];
export type PageName = PageBlockDef["page"];

// i18n value bag: { it, en, de } (all optional; `it` is the fallback).
const I18n = z.record(z.string());

export const PageBlockPatchInput = z.object({
  page: z.string().min(1).max(64),
  block_key: z.string().min(1).max(120),
  value: I18n,
});
export type PageBlockPatchInput = z.infer<typeof PageBlockPatchInput>;
